<template>
  <nav id="header__top">
    <div class="container-fluid l2">
      <div class="row g-0">
        <div
            v-for="menuItem in items"
            :key="menuItem.id"
            class="col-auto"
        >
          <IoRouterLink
              :link-url="menuItem.url"
              :link-target="menuItem.target"
              :link-title="menuItem.titleAttr"
              :active="menuItem.active"
          >
            <span v-html="menuItem.title"></span>
          </IoRouterLink>
        </div>
        <div class="col"></div>
        <div
            v-if="batlanticUrl"
            class="col-auto batlantic">
          <a :href="batlanticUrl" target="_blank">
            <img :src="batlanticIcon">
            <span>badlantic</span>
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script lang="ts" setup>
import MenuInterface from '@/interfaces/MenuInterface';

defineProps<{
  items: MenuInterface[]
}>();

const batlanticIcon = window.ioappConfig.badlanticLogo;
const batlanticUrl = window.ioappConfig.badlanticUrl;
</script>

<style lang="scss">
@import "src/scss/component-helpers";

#header__top {
  background-color: $body-bg-secondary;
  display: none;

  .container-fluid {
    height: 2.5rem;
  }

  a {
    display: inline-block;
    font-size: 14px;
    font-weight: 300;
    padding: 12px 20px 8px 20px;
    transition: background-color 0.35s ease;
    will-change: background-color;
    text-decoration: none;
    color: #38383A;
    height: 100%;

    &.active {
      background-color: #FFFFFF;
    }

    &:hover {
      background-color: #FFFFFF;
      text-decoration: none;
    }
  }

  .batlantic {
    background: $gradient-brand;
    height: 2.5rem;

    &:before{
      content: "";
      display: block;
      width: 0.625rem;
      height: 2.5rem;
      background: transparent linear-gradient(90deg, #000000 0%, #00000000 100%) 0% 0% no-repeat padding-box;
      opacity: 0.1;
      position: absolute;
    }

    a {
      color: #FFFFFF;
      font-weight: 700;
      font-size: 1rem;
      padding: 0.5rem 1.25rem 0.438rem 0;
    }

    a:hover {
      background-color: transparent;
    }

    img {
      width: 1rem;
      margin: 0 0.625rem 0.125rem 1.25rem;
    }

    span {
      margin: auto 0;
    };
  }

  .col-auto:last-child {
    a {
      &:after{
        content: "";
        width: 0.625rem;
        height: 2.8rem;
        background: transparent linear-gradient(90deg, #000000 0%, #00000000 100%) 0% 0% no-repeat padding-box;
        opacity: 0.1;
        position: absolute;
        transform: rotate(180deg);
        margin-top: -0.8rem;
        margin-left: 0.6rem;
      }
    }
  }

  header.desktop & {
    display: block;
  }
}
</style>
